import { useEffect, useState } from "react";

/**
 * The arrival. You come down through cloud and the World is under you.
 *
 * Ported from the founder's Design build: two banks of cloud pull apart sideways,
 * two lower banks sink, and a bright haze burns off last — so the plate does not
 * fade in, it is REVEALED. Nothing is named until the clouds have gone.
 *
 * First arrival per browser session only. Nobody wants a three-second overture
 * every time they hit the map, and a judge clicking back and forth would hate it.
 */
const SEEN = "endeavorum.arrived";

export const hasArrived = () => {
  if (skip()) return true;
  try {
    return sessionStorage.getItem(SEEN) === "1";
  } catch {
    return true;
  }
};

/**
 * Never make a machine sit through the overture. Gallery thumbnailers, link
 * unfurlers and crawlers screenshot within a second or two — if they caught the
 * cloud, our card in the Builderfest grid would be a pale blur. `?nointro` does
 * the same thing by hand.
 */
const BOTS =
  /bot|crawl|spider|slurp|headless|lighthouse|preview|screenshot|unfurl|facebookexternalhit|twitterbot|slackbot|whatsapp|discord|linkedinbot|embedly|pinterest|telegram/i;

const skip = () => {
  if (typeof window === "undefined") return true;
  if (new URLSearchParams(window.location.search).has("nointro")) return true;
  if (BOTS.test(navigator.userAgent)) return true;
  return !!window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
};

export const CloudReveal = () => {
  const [gone, setGone] = useState(false);

  useEffect(() => {
    try {
      sessionStorage.setItem(SEEN, "1");
    } catch (err) {
      // Private mode — the overture simply plays again. Not an error.
      console.debug("[CloudReveal] sessionStorage unavailable:", err);
    }
    const t = setTimeout(() => setGone(true), 3600);
    return () => clearTimeout(t);
  }, []);

  if (gone || skip()) return null;

  return (
    <div
      className="pointer-events-none absolute inset-0 z-40"
      data-testid="cloud-reveal"
      aria-hidden
    >
      <div className="veil-dark absolute inset-0" />
      <div className="cloud-l absolute" style={{ inset: "-6%" }} />
      <div className="cloud-r absolute" style={{ inset: "-6%" }} />
      <div className="cloud-low-l absolute" style={{ inset: "-8%" }} />
      <div className="cloud-low-r absolute" style={{ inset: "-8%" }} />
      <div className="haze absolute inset-0" />
    </div>
  );
};

export default CloudReveal;
